import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { SessionProvider } from './context/SessionContext'; 
import { LoadingProvider } from './context/LoadingContext'
import App from './App';

import 'antd/dist/reset.css';
import './styles/app.css';
import './styles/custom.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      cacheTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <SessionProvider>
        <LoadingProvider> 
          <ConfigProvider
            theme={{
              token: {
                fontFamily: `'Manrope', 'Segoe UI', system-ui, -apple-system, sans-serif`,
              },
            }}
          >
            <App />
          </ConfigProvider>
        </LoadingProvider>
      </SessionProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
